import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-607594a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-5 p-lg-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mb-8 mb-lg-10"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/betcomrade-logo.svg",
    class: "auth-logo"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_view)
    ])
  ]))
}